import { forwardRef, type Ref, type SVGProps } from "react";
const IconSyncOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M8 25H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h11.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 0 0-1.414 1.414L16.586 5H5a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h3a1 1 0 1 0 0-2M27 5h-3a1 1 0 1 0 0 2h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H15.414l2.293-2.293a1 1 0 1 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L15.414 27H27a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3" />
  </svg>
);
const ForwardRef = forwardRef(IconSyncOutlineSVG);
ForwardRef.displayName = "IconSyncOutline";
export { ForwardRef as IconSyncOutline };
